<div
  class="toast-container position-fixed top-0 end-0 p-3"
  style="z-index: 1200;"
>
  <ng-container *ngFor="let toast of toastService.toasts">
    <div
      class="toast align-items-center show"
      [class]="toast.classname"
      [ngStyle]="toast.style || null"
      role="alert"
      [attr.aria-live]="'assertive'"
      [attr.aria-atomic]="'true'"
    >
      <div class="d-flex">
        <div class="toast-body">
          <strong *ngIf="toast.header">{{ toast.header }}</strong>
          <div *ngIf="toast.isHtml; else textBody" [innerHTML]="toast.body"></div>
          <ng-template #textBody>
            <div>{{ toast.body }}</div>
          </ng-template>
        </div>
        <button
          type="button"
          class="btn-close btn-close-white me-2 m-auto"
          aria-label="Close"
          (click)="toastService.remove(toast)"
        ></button>
      </div>
    </div>
  </ng-container>
</div>
